var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"get-directions",attrs:{"text":"","href":_vm.directionsLink,"target":"blank"}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v("\n    mdi-directions\n  ")]),_vm._v("\n  Get directions\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }